
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/shopping-in-fansi",
      function () {
        return require("private-next-pages/help/shopping-in-fansi.tsx");
      }
    ]);
  